import { apiClient } from './apiClient';
import { authService } from './authService';

const getCompanyParam = () => {
  const companyId = authService.getCompanyId();
  return companyId ? `companyId=${companyId}` : '';
};

export const branchService = {
  // Get all branches
  async getBranches() {
    return apiClient.get(`/api/cmms/branches?${getCompanyParam()}`);
  },

  // Get branches by status
  async getBranchesByStatus(status) {
    return apiClient.get(`/api/cmms/branches/status/${status}?${getCompanyParam()}`);
  },

  // Get branches by type
  async getBranchesByType(type) {
    return apiClient.get(`/api/cmms/branches/type/${type}?${getCompanyParam()}`);
  },

  // Get single branch by ID
  async getBranchById(id) {
    return apiClient.get(`/api/cmms/branches/${id}?${getCompanyParam()}`);
  },

  // Get branch by code
  async getBranchByCode(code) {
    return apiClient.get(`/api/cmms/branches/code/${code}?${getCompanyParam()}`);
  },

  // Create new branch
  async createBranch(data) {
    return apiClient.post(`/api/cmms/branches?${getCompanyParam()}`, data);
  },

  // Update branch
  async updateBranch(id, data) {
    return apiClient.put(`/api/cmms/branches/${id}?${getCompanyParam()}`, data);
  },

  // Delete branch
  async deleteBranch(id) {
    return apiClient.delete(`/api/cmms/branches/${id}?${getCompanyParam()}`);
  },
};
